var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"print-view-container"},[_c('MainHeader',{staticClass:"main-header"}),_c('PrintGenerator',{staticClass:"mb-12",attrs:{"id":_vm.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }